export const CHECKOUT_URL =
  "https://reparaciones.impultienda.ar/checkout/reparaciones";
